export function assertNever(v: never): never {
    throw new Error(`Received unexpected value: ${JSON.stringify(v)}`);
}

export function logNever(v: never): void;
export function logNever<T>(v: never, returnValue: T): T;
export function logNever(v: never, returnValue?: unknown): unknown {
    // TODO(@lucaslemanowicz): Re-implement to push to new logging infrastructure
    console.error("Unexpected value.", v);

    return returnValue;
}
